import { render, staticRenderFns } from "./participant-details-contacts.vue?vue&type=template&id=59ed3d76&scoped=true"
import script from "./participant-details-contacts.vue?vue&type=script&lang=js"
export * from "./participant-details-contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed3d76",
  null
  
)

export default component.exports